import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from '@emotion/react';
import AuthHandler from '../../../helper/AuthHandler';
import { ClipLoader } from "react-spinners";
import { MapContainer, Marker, Popup, TileLayer, LayersControl, CircleMarker, Circle, useMapEvents } from 'react-leaflet';
import { DatePicker, TimePicker } from "antd";
import {
    postLocation,
    // fetchMsisdnList,
    fetchSettlementTyps,
    fetchSingleApp,
    submitMsisdn,
    submitMsisdnOtp
} from '../../../store/actions';
import L from 'leaflet';
import Moment from 'moment';
import { postMsisdn, postMsisdnOtp } from '../../../services/user.service';
import SimpleReactValidator from 'simple-react-validator';
import * as CONSTANTS from '../../../constants';
import { confirmAlert } from 'react-confirm-alert';
import { onSearch } from "../../../services/widgets.service";
import dayjs from 'dayjs';
import MarkerMapIcon from '../../../assets/images/Marker.svg';
import { PageHeaderStatic } from "../components/PageHeaderStatic";
import { InputTextFieldWithButton } from "../../../components";

const override: CSSProperties = {
    display: "block",
    margin: "0 auto"
};

const LocationTrackCreate = ({ auth }: any) => {
    const mapRef = useRef<any>(null);
    const { wid } = useParams();
    const [trackList, setTrackList] = useState([]);
    const [screen, setScreen] = useState('add-location-track');
    const [latitude, setLatitude] = useState(6.927079);
    const [longitude, setLongitude] = useState(79.861244);
    const [radius, setRadius] = useState(500);
    const [zoom, setZoom] = useState(13);
    const [animate, setAnimate] = useState(false);
    const [latlng, setLatlng] = useState({ lat: 6.927079, lng: 79.861244 });
    const [bounds, setBounds] = useState([
        [50.505, -29.09],
        [52.505, 29.09],
    ]);
    const [searchText, setSearchText] = useState("");
    const [alertReceiving, setAlertReceiving] = useState('');
    const [alertReceivingError, setAlertReceivingError] = useState('');
    const [receiverOtp, setReceiverOtp] = useState('');
    const [receiverOtpError, setReceiverOtpError] = useState('');
    const [receiverOtpLoading, setReceiverOtpLoading] = useState(false);
    const [receiverOtpSuccess, setReceiverOtpSuccess] = useState<boolean | null>(null);
    const [receiverServerRef, setReceiverServerRef] = useState('');
    const [receiverOtpReadOnly, setReceiverOtpReadOnly] = useState(false);
    const [trackerNumber, setTrackerNumber] = useState('');
    const [trackerNumberError, setTrackerNumberError] = useState('');
    const [trackerOtp, setTrackerOtp] = useState('');
    const [trackerOtpError, setTrackerOtpError] = useState('');
    const [trackerOtpLoading, setTrackerOtpLoading] = useState(false);
    const [trackerOtpSuccess, setTrackerOtpSuccess] = useState<boolean | null>(null);
    const [trackerServerRef, setTrackerServerRef] = useState('');
    const [trackerOtpReadOnly, setTrackerOtpReadOnly] = useState(false);
    const [checkedDays, setCheckedDays] = useState([]);
    const [mon, setMon] = useState(false);
    const [tue, setTue] = useState(false);
    const [wed, setWed] = useState(false);
    const [thu, setThu] = useState(false);
    const [fri, setFri] = useState(false);
    const [sat, setSat] = useState(false);
    const [sun, setSun] = useState(false);
    const [dayError, setDayError] = useState('');
    const [time, setTime] = useState('');
    const [timeError, setTimeError] = useState('');
    const [status, setStatus] = useState("Active");
    const [trackerName, setTrackerName] = useState('');
    const [trackerNameError, setTrackerNameError] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [title, setTitle] = useState("");
    const [expiredate, setExpiredate] = useState("");
    const [termsAndConditions, setTermsAndConditions] = useState<boolean>(false);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
    const [termsAndConditionsDetailsState, setTermsAndConditionsDetails] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [locationSubmitErrorMessageState, setLocationSubmitErrorMessage] = useState('');
    const [paymentMethodId, setPaymentMethodId] = useState('');
    const [showReceiverMsisdnOtpField, setShowReceiverMsisdnOtpField] = useState(false);
    const [receiverRemainingTime, setReceiverRemainingTime] = useState(0);
    const [receiverMobileVerified, setReceiverMobileVerified] = useState<string | undefined>();

    const [showTrackingMsisdnOtpField, setShowTrackingMsisdnOtpField] = useState(false);
    const [trackingRemainingTime, setTrackingRemainingTime] = useState(0);
    const [trackingMobileVerified, setTrackingMobileVerified] = useState<string | undefined>();

    const [otpSender, setOtpSender] = useState('receiver');
    const [locationSelected, setLocationSelected] = useState(false);

    const [validator] = useState(new SimpleReactValidator({
        messages: {
            required: 'You can’t keep this as empty',
            min: 'Minimum length is :min',
            max: 'Maximum length is :max',
        },
        validators: {
            all_mobiles: {
                message: 'The entered :attribute number is invalid.',
                rule: (val: any, params?: any, validator?: any): boolean => {
                    return validator.helpers.testRegex(val, /^[0]{1}[123456789]{2}\d{7}$/) && params.indexOf(val) === -1
                }
            },
            dialog: {
                message: 'The :attribute is invalid.',
                rule: (val: any, params?: any, validator?: any): boolean => {
                    return validator.helpers.testRegex(val, /^([0]{1}[7]{1}[764]{1}\d{7}|[7]{1}[764]{1}\d{7})$/) && params.indexOf(val) === -1
                }
            }
        },
        autoForceUpdate: this
    }));

    const navigate = useNavigate();

    const position = { lat: latitude, lng: longitude };
    const MarkerIcon = L.icon({
        iconUrl: MarkerMapIcon,
        iconRetinaUrl: MarkerMapIcon,
        iconSize: new L.Point(50, 50),
        className: 'leaflet-div-icon'
    });

    const otpTextValidator = new SimpleReactValidator({
        messages: {
            required: 'You can’t keep this as empty',
            min: 'Minimum length is :min',
            max: 'Maximum length is :max',
        },
        autoForceUpdate: this
    });

    const {
        singleAppDetails
    } = useSelector(({ apps }: any) => apps);

    const {
        termsAndConditionsDetails,
        locationSubmitError,
        locationSubmitErrorMessage,
        locationSubmitLoading,
        locationSubmitSuccess,
        settlement_types
    } = useSelector(({ location }: any) => location);

    const {
        msisdnData,
        msisdnOtpData,
        userDetails
    } = useSelector<any, any>(({ user }) => user);

    const dispatch = useAppDispatch();

    const useForceUpdate = () => {
        const [value, setValue] = useState(0);
        return () => setValue(value => value + 1);
    }

    const forceUpdate = useForceUpdate()

    const onChangeTitle = (e: any) => {
        setTitle(e.target.value);
    }

    const onReceiverOtpChange = (name: string) => (e: any) => {
        setReceiverOtp(e.target.value);
        setReceiverOtpError('');
    }
    const onTrackerNumberChange = (name: string) => (e: any) => {
        setTrackerNumber(e.target.value);
    }
    const onTrackerOtpChange = (name: string) => (e: any) => {
        setTrackerOtp(e.target.value);
        setTrackerOtpError('');
    }
    const onChangeTrackerName = (e: any) => {
        setTrackerName(e.target.value);
    }
    const onSearchLocation = (e: any) => {
        setLocationSelected(false);
        setSearchText(e.target.value);
    }

    useEffect(() => {
        if (searchText !== '' && !locationSelected) {
            var searchString = searchText.replace(/,/g, "%2C");
            searchString = searchString.replace(/ /g, "+");
            onSearch(searchString).then((data) => {
                setSearchResult(data.data);
            });
        }
    }, [searchText]);

    const onSelectSearch = (value: any) => {
        var lat = parseFloat(value.lat);
        var lon = parseFloat(value.lon);
        setSearchText(value.display_name);
        setLocationSelected(true);
        setSearchResult([]);
        setLatitude(lat);
        setLongitude(lon)
    }

    const onMapPress = (e: any) => {
        setLongitude(e.latlng.lng);
        setLatitude(e.latlng.lat);
    }
    const onDragMarker = (e: any) => {
        try {
            setLongitude(e.target._latlng.lng);
            setLatitude(e.target._latlng.lat);
        } catch (err) {
            console.log(err);
        }
    }
    const onSetZoom = (e: any) => {
        try {
            setZoom(e.target._zoom);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (mapRef.current) {
            // Perform animation after the map is initialized
            mapRef.current.setView(position, 13, { animate: true });
            // Add event listener for zoomstart event
            mapRef.current.on('zoomstart', onSetZoom);
            mapRef.current.on('click', onMapPress);

        }

        // Remove event listener on component unmount
        return () => {
            if (mapRef.current) {
                mapRef.current.off('zoomstart', onSetZoom);
                mapRef.current.off('click', onMapPress);
            }
        };
    }, [mapRef, position]);

    // useMapEvents({
    //     zoomstart: (e: any) => {
    //         setZoom(e.target._zoom);
    //     },
    //     click: (e: any) => {
    //         setLongitude(e.latlng.lng);
    //         setLatitude(e.latlng.lat);
    //     },
    // });

    const onChangeRadius = (e: any) => {
        setRadius(e.target.value);
    }
    const onChangeMon = (e: any) => {
        setMon(e.target.checked);
        setDayError('');
    }
    const onChangeTue = (e: any) => {
        setTue(e.target.checked);
        setDayError('');
    }
    const onChangeWed = (e: any) => {
        setWed(e.target.checked);
        setDayError('');
    }
    const onChangeThu = (e: any) => {
        setThu(e.target.checked);
        setDayError('');
    }
    const onChangeFri = (e: any) => {
        setFri(e.target.checked);
        setDayError('');
    }
    const onChangeSat = (e: any) => {
        setSat(e.target.checked);
        setDayError('');
    }
    const onChangeSun = (e: any) => {
        setSun(e.target.checked);
        setDayError('');
    }

    const onChangeTime = (value: any) => {
        setTime(value);
    }

    const onChangeExpireDate = (value: any, dateString: string) => {
        setExpiredate(value ? Moment(value).toString() : '');
    }

    const disabledDate = (current: any) => {
        return current < Moment().startOf('day');
    }

    useEffect(() => {
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        dispatch(fetchSingleApp(wid!, tenantGUID));
    }, [wid, userDetails]);

    useEffect(() => {
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        if (singleAppDetails && singleAppDetails.widgetDetails) {
            dispatch(fetchSettlementTyps(tenantGUID, singleAppDetails.widgetDetails.uuid));
        }
    }, [userDetails, singleAppDetails]);

    useEffect(() => {
        if (userDetails && userDetails.OwnedEnterprises[0] && userDetails.OwnedEnterprises[0].Enterprise && userDetails.OwnedEnterprises[0].Enterprise.billingStatus == 'Invoice') {
            setAlertReceiving((userDetails && Array.isArray(userDetails.OwnedEnterprises) && userDetails.OwnedEnterprises.length > 0 && userDetails.OwnedEnterprises[0].Enterprise) ? userDetails.OwnedEnterprises[0].Enterprise.ownerMobile : '');
            if (settlement_types && settlement_types.paymentMethodId != null) {
                setPaymentMethodId(settlement_types.paymentMethodId);
            }
        } else {
            if (settlement_types && settlement_types.paymentMethodId != null) {
                setPaymentMethodId(settlement_types.paymentMethodId);
                if (settlement_types.paymentMethodId == '1') {
                    setAlertReceiving(settlement_types.Msisdns ? settlement_types.Msisdns.msisdn : '');
                } else {
                    setAlertReceiving((userDetails && Array.isArray(userDetails.OwnedEnterprises) && userDetails.OwnedEnterprises.length > 0 && userDetails.OwnedEnterprises[0].Enterprise) ? userDetails.OwnedEnterprises[0].Enterprise.ownerMobile : '');
                }
            }
        }
    }, [settlement_types, userDetails]);

    useEffect(() => {
        if (formSubmitted) {
            setSaveSuccess(locationSubmitSuccess);
            setSaveError(locationSubmitError);
            setSaveLoading(locationSubmitLoading);
            setLocationSubmitErrorMessage(locationSubmitErrorMessage);
        }
    }, [formSubmitted, locationSubmitSuccess, locationSubmitError, locationSubmitLoading]);

    useEffect(() => {
        let intervalId: any = null;

        if (receiverRemainingTime > 0) {
            intervalId = setInterval(() => {
                setReceiverRemainingTime((prevTime) => prevTime - 1);
            }, 1000);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [receiverRemainingTime]);

    useEffect(() => {
        let intervalId: any = null;

        if (trackingRemainingTime > 0) {
            intervalId = setInterval(() => {
                setTrackingRemainingTime((prevTime) => prevTime - 1);
            }, 1000);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [trackingRemainingTime]);

    useEffect(() => {
        setSubmitDisabled(!termsAndConditions);
    }, [termsAndConditions]);

    const onConfirmationTerms = (e: any) => {
        setTermsAndConditions(e.target.checked);
    }

    const handleWidgetSave = async () => {
        // console.log("$$$$$$$$$$$$$$$$$$$$$", receiverMobileVerified === "verified", trackingMobileVerified === "verified", validator.allValid(), (mon || tue || wed || thu || fri || sat || sun));

        if (otpTextValidator.fieldValid("recieverOtp")) {
            if (receiverMobileVerified !== "verified") {
                setReceiverOtpError('Please verify mobile number');
            }
        }
        if (otpTextValidator.fieldValid("trackerOtp")) {
            if (trackingMobileVerified !== "verified") {
                setTrackerOtpError('Please verify mobile number');
            }
        }
        if (receiverMobileVerified === "verified" && trackingMobileVerified === "verified" && validator.allValid() && (mon || tue || wed || thu || fri || sat || sun)) {
            confirmAlert({
                message: CONSTANTS.CHILD_TRACKING_SAVE,
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => submitTrackingData()
                    },
                    {
                        label: 'No',
                    }
                ]
            });
        } else {
            validator.showMessages();
            forceUpdate();
            setSaveSuccess(false);
            setSaveError(false);
            setSaveLoading(false);
            setLocationSubmitErrorMessage('');
            if (!mon && !tue && !wed && !thu && !fri && !sat && !sun) {
                setDayError('Please select a day');
            }
        }
    }

    const submitTrackingData = async () => {
        var trackingData = {
            "title": title,
            "trackingNumber": trackerNumber,
            "trackerNumber": alertReceiving,
            "personName": trackerName,
            "location": searchText,
            "longitude": longitude,
            "latitude": latitude,
            "radius": radius,
            "monday": mon,
            "tuesday": tue,
            "wednesday": wed,
            "thursday": thu,
            "friday": fri,
            "saturday": sat,
            "sunday": sun,
            "status": status,
            "trackTime": dayjs(time).format('HH:mm'),
            "expiredAt": dayjs(expiredate).format('YYYY-MM-DD HH:mm:ss'),
            "trackerOTPVerified": "Verify",
            "trackingOTPVerified": "Verify",
            "trackerOTPReference": receiverServerRef,
            "trackingOTPReference": trackerServerRef,
            "taAccepted": "2020-10-05 00:00:00"
        };

        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";

        setFormSubmitted(true);
        dispatch(postLocation(trackingData, tenantGUID, singleAppDetails?.widgetDetails?.uuid, navigate));

        setTitle("");
        setSaveSuccess(locationSubmitSuccess);
        setSaveError(locationSubmitError);
        setSaveLoading(locationSubmitLoading);
        setLocationSubmitErrorMessage(locationSubmitErrorMessage);
        setLatitude(6.927079);
        setLongitude(79.861244);
        setRadius(500);
        setZoom(13);
        setAnimate(false);
        setLatlng({ lat: 6.927079, lng: 79.861244 });
        setBounds([
            [50.505, -29.09],
            [52.505, 29.09],
        ]);
        setSearchText("");
        setAlertReceiving("");
        setAlertReceivingError("");
        setReceiverOtp("");
        setReceiverOtpError("");
        setReceiverOtpLoading(false);
        setReceiverOtpSuccess(null);
        setReceiverServerRef("");
        setReceiverOtpReadOnly(false);
        setTrackerNumber("");
        setTrackerOtp("");
        setTrackerOtpError("");
        setTrackerOtpLoading(false);
        setTrackerOtpSuccess(null);
        setTrackerServerRef("");
        setTrackerOtpReadOnly(false);
        setCheckedDays([]);
        setMon(false);
        setTue(false);
        setWed(false);
        setThu(false);
        setFri(false);
        setSat(false);
        setSun(false);
        setDayError("");
        setTime("");
        setTimeError("");
        setStatus("Active");
        setTrackerName("");
        setTrackerNameError("");
        setSearchResult([]);
        setSubmitDisabled(true);
        setShowTermsAndConditions(false);
        setTermsAndConditionsDetails("");
        setPaymentMethodId("");

        // The validator hideMessageFor calls can be removed as they are not relevant for hooks-based implementation.
    };

    const renderSearchList = () => {
        return (
            <ul className="dropdown-list">
                {searchResult && searchResult.map(function (value: any, index: number) {
                    return (
                        <li className="dropdown-item" key={index}>
                            <a onClick={() => onSelectSearch(value)}>{value.display_name}</a>
                        </li>
                    )
                })}
            </ul>
        )
    }


    const renderReceiverOtpButton = () => {
        if (receiverOtpLoading) {
            return (
                <button className="btn btn-success btn-sm btn-transparent">
                    <span className="spinner-border spinner-border-sm spinner-color" role="status"
                        aria-hidden="true"></span>
                </button>
            );
        } else {
            if (receiverOtpSuccess === null || receiverOtpSuccess === false) {
                return (
                    <button
                        className="btn btn-success btn-sm"
                        onClick={onVerifyReceiverOtp}
                    >
                        Verify
                    </button>
                );
            } else if (receiverOtpSuccess === true) {
                return (
                    <button className="btn btn-success btn-sm btn-transparent">
                        <i className="fa fa-check otp-success"></i>
                    </button>
                );
            }
        }
    }

    const renderTrackerOtpButton = () => {
        if (trackerOtpLoading) {
            return (
                <button className="btn btn-success btn-sm btn-transparent">
                    <span className="spinner-border spinner-border-sm spinner-color" role="status"
                        aria-hidden="true"></span>
                </button>
            );
        } else {
            if (trackerOtpSuccess === null || trackerOtpSuccess === false) {
                return (
                    <button
                        className="btn btn-success btn-sm"
                        onClick={onVerifyTrackerOtp}
                    >
                        Verify
                    </button>
                );
            } else if (trackerOtpSuccess === true) {
                return (
                    <button className="btn btn-success btn-sm btn-transparent">
                        <i className="fa fa-check otp-success"></i>
                    </button>
                );
            }
        }
    }

    const renderSubmitButton = () => {
        if (AuthHandler.isPerformable(auth, "add-location-track")) {
            return (
                <button className="btn btn-primary" onClick={handleWidgetSave} disabled={submitDisabled}>Save &amp; Continue</button>
            )
        } else {
            return (
                <button type="button" className="btn btn-primary" disabled={true}>You don't have access to
                    create a location track</button>
            )
        }
    }

    useEffect(() => {
        if (msisdnData && msisdnData.data) {
            if (otpSender === 'receiver') {
                setShowReceiverMsisdnOtpField(true);
                setReceiverRemainingTime(120);
                setReceiverServerRef(msisdnData.data.serverRef);
            } else {
                setShowTrackingMsisdnOtpField(true);
                setTrackingRemainingTime(120);
                setTrackerServerRef(msisdnData.data.serverRef);
            }
            forceUpdate();
        }
    }, [msisdnData])

    useEffect(() => {
        if (otpSender === 'receiver') {
            if (msisdnOtpData && msisdnOtpData.data && msisdnOtpData.data.data && msisdnOtpData.data.data.status === "SUCCESS") {
                setReceiverMobileVerified("verified")
                setShowReceiverMsisdnOtpField(false)
            }
            if (msisdnOtpData && msisdnOtpData.status === "ERROR") {
                setReceiverMobileVerified("notVerified")
            }
        } else {
            if (msisdnOtpData && msisdnOtpData.data && msisdnOtpData.data.data && msisdnOtpData.data.data.status === "SUCCESS") {
                setTrackingMobileVerified("verified")
                setShowTrackingMsisdnOtpField(false)
            }
            if (msisdnOtpData && msisdnOtpData.status === "ERROR") {
                setTrackingMobileVerified("notVerified")
            }
        }
    }, [msisdnOtpData]);

    const onSendTrackerOtp = async () => {
        setOtpSender('tracker');
        if (validator.fieldValid('trackerNumber')) {
            const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
            let mobileNo = trackerNumber;
            if (trackerNumber.length == 9) {
                mobileNo = "94" + mobileNo;
            } else {
                if (trackerNumber.charAt(0) === "0") {
                    mobileNo = "94" + mobileNo.slice(1);
                }
            }
            const req = {
                method: "ANC",
                msisdn: mobileNo
            }
            dispatch(submitMsisdn(req, tenantGUID));
        } else {
            validator.showMessageFor('trackerNumber');
            forceUpdate();
        }
    }
    const onVerifyTrackerOtp = async () => {
        setOtpSender('tracker');
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        if (otpTextValidator.fieldValid("trackerOtp")) {
            setTrackerOtpLoading(true);
            setTrackerOtpError('');
            const req = {
                pin: trackerOtp,
                serverRef: trackerServerRef
            }
            dispatch(submitMsisdnOtp(req, tenantGUID));
        } else {
            otpTextValidator.showMessageFor("trackerOtp");
            forceUpdate();
        }
    }

    const onSendReceiverOtp = async () => {
        setOtpSender('receiver');
        if (validator.fieldValid('alertReceiving')) {
            const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
            // console.log("##############", alertReceiving);
            let mobileNo = alertReceiving;
            if (alertReceiving.length == 9) {
                mobileNo = "94" + mobileNo;
            } else {
                if (alertReceiving.charAt(0) === "0") {
                    mobileNo = "94" + mobileNo.slice(1);
                }
            }

            const req = {
                method: "ANC",
                msisdn: mobileNo
            }
            dispatch(submitMsisdn(req, tenantGUID))
        } else {
            validator.showMessageFor('alertReceiving');
            forceUpdate();
        }
    }

    const onVerifyReceiverOtp = async () => {
        setOtpSender('receiver');
        if (otpTextValidator.fieldValid("recieverOtp")) {
            setReceiverOtpLoading(false);
            setReceiverOtpError('');
            const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
            const req = {
                pin: receiverOtp,
                serverRef: receiverServerRef
            }
            dispatch(submitMsisdnOtp(req, tenantGUID));
        } else {
            otpTextValidator.showMessageFor("recieverOtp");
            forceUpdate();
        }
    }

    const renderOwnersNumber = () => {
        if (paymentMethodId) {
            return (
                <>
                    {(!showReceiverMsisdnOtpField || receiverRemainingTime == 0) ?
                        <InputTextFieldWithButton
                            name='alertReceiving'
                            label='Owner number'
                            placeholder='Charging number'
                            value={alertReceiving}
                            setValue={() => () => { }}
                            validator={validator}
                            rules={['required', 'dialog']}
                            disabled={true}
                            status={(receiverMobileVerified === "verified") ? "verified" : (receiverMobileVerified === "notVerified") ? "notVerified" : ""}
                            validationMessage={(receiverMobileVerified === "verified") ? "Verified!" : (receiverMobileVerified === "notVerified") ? "Not verified! please use correct type of Number" : ""}
                            buttonLable="Verify"
                            showButton={true}
                            onClickFunc={onSendReceiverOtp}
                            forceUpdate={forceUpdate}
                            buttonDisabled={(receiverMobileVerified && receiverMobileVerified === "verified") ? true : false}
                            preValueCheck={false}
                            errorText={receiverOtpError}
                            showRemainingTime={showReceiverMsisdnOtpField}
                            remainingTime={receiverRemainingTime}
                        />
                        :
                        <InputTextFieldWithButton
                            name='recieverOtp'
                            label='Enter OTP'
                            placeholder='123456'
                            value={receiverOtp}
                            setValue={onReceiverOtpChange}
                            validator={otpTextValidator}
                            rules={['required', 'numeric', { min: 6 }, { max: 6 }]}
                            disabled={false}
                            status={(receiverMobileVerified === "verified") ? "verified" : (receiverMobileVerified === "notVerified") ? "notVerified" : ""}
                            validationMessage={(receiverMobileVerified === "verified") ? "Verified!" : (receiverMobileVerified === "notVerified") ? "Not verified! please use correct type of Number" : ""}
                            buttonLable="Submit"
                            showButton={true}
                            onClickFunc={onVerifyReceiverOtp}
                            buttonDisabled={false}
                            forceUpdate={forceUpdate}
                            preValueCheck={false}
                            showRemainingTime={showReceiverMsisdnOtpField}
                            remainingTime={receiverRemainingTime}
                        />}
                </>
            )
        }
    }

    const renderTrackingNumber = () => {
        return (
            <>
                {(!showTrackingMsisdnOtpField || trackingRemainingTime == 0) ?
                    <InputTextFieldWithButton
                        name='trackerNumber'
                        label="Tracking person's number"
                        placeholder="Tracking person's number"
                        value={trackerNumber}
                        setValue={onTrackerNumberChange}
                        validator={validator}
                        rules={['required', 'dialog']}
                        disabled={(trackingMobileVerified && trackingMobileVerified === "verified") ? true : false}
                        status={(trackingMobileVerified === "verified") ? "verified" : (trackingMobileVerified === "notVerified") ? "notVerified" : ""}
                        validationMessage={(trackingMobileVerified === "verified") ? "Verified!" : (trackingMobileVerified === "notVerified") ? "Not verified! please use correct type of Number" : ""}
                        buttonLable="Verify"
                        showButton={true}
                        onClickFunc={onSendTrackerOtp}
                        forceUpdate={forceUpdate}
                        buttonDisabled={(trackingMobileVerified && trackingMobileVerified === "verified") ? true : false}
                        preValueCheck={false}
                        errorText={trackerOtpError}
                        showRemainingTime={showTrackingMsisdnOtpField}
                        remainingTime={trackingRemainingTime}
                    />
                    :
                    <InputTextFieldWithButton
                        name='trackerOtp'
                        label='Enter OTP'
                        placeholder='123456'
                        value={trackerOtp}
                        setValue={onTrackerOtpChange}
                        validator={otpTextValidator}
                        rules={['required', 'numeric', { min: 6 }, { max: 6 }]}
                        disabled={false}
                        status={(trackingMobileVerified === "verified") ? "verified" : (trackingMobileVerified === "notVerified") ? "notVerified" : ""}
                        validationMessage={(trackingMobileVerified === "verified") ? "Verified!" : (trackingMobileVerified === "notVerified") ? "Not verified! please use correct type of Number" : ""}
                        buttonLable="Submit"
                        showButton={true}
                        onClickFunc={onVerifyTrackerOtp}
                        buttonDisabled={false}
                        forceUpdate={forceUpdate}
                        preValueCheck={false}
                        showRemainingTime={showTrackingMsisdnOtpField}
                        remainingTime={trackingRemainingTime}
                    />}
            </>
        )
    }

    if (AuthHandler.isAuthorized(auth, 'add-location-track') && userDetails !== null) {
        return (
            <React.Fragment>
                <div className="main-content main-spacer-x-y">
                    <PageHeaderStatic
                        page={'create'}
                    />
                    <div className="card added-app-thumbnnail__wrapper">
                        <div
                            className="added-app-thumbnail__inner"
                            style={{
                                backgroundImage: `url(${(singleAppDetails && singleAppDetails.widgetDetails !== null) ? singleAppDetails.widgetDetails.leftImage : ""})`
                            }}
                        ></div>
                    </div>
                    <div className="card panel content-holder-panels added-app-form__wrapper">
                        <div className="panel-header">
                            <div className="panel-header-content__wrapper">
                                <h4 className="panel-header-title">New Tracking Request</h4>
                            </div>
                        </div>
                        <div className="panel-content">
                            <div className="wiz-content-form__wrapper">
                                <p>
                                    Are you sure your employees are at the correct place? Well,
                                    Let's find out by getting an SMS.
                                </p>
                                <br />
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Title
                                            </label>
                                            <input
                                                type="text"
                                                id="tile"
                                                className="form-control"
                                                value={title}
                                                onChange={onChangeTitle}
                                                placeholder="Title for the service"
                                            />
                                            <div className="validation invalid-feedback">{validator.message('title', title, 'required|alpha_num_dash_space')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        {renderOwnersNumber()}
                                    </div>
                                    <div className="form-group">
                                        {renderTrackingNumber()}
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Tracking person's name
                                            </label>
                                            <input
                                                type="text"
                                                id="otp"
                                                className="form-control"
                                                value={trackerName}
                                                onChange={onChangeTrackerName}
                                                placeholder="Your tracker's name"
                                            />
                                            <div className="validation invalid-feedback">{validator.message('tracker name', trackerName, 'required|alpha_space')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3 has-dropdown">
                                            <label htmlFor="" className="form-label">
                                                Search location
                                            </label>
                                            <div className="icon-inside right">
                                                <span className="in-icon" onClick={() => {
                                                    setSearchText('');
                                                    setLocationSelected(false);
                                                    setSearchResult([]);
                                                }}>
                                                    <i className={searchText == '' ? "bi bi-search" : "bi bi-x"} />
                                                </span>
                                                <input
                                                    type="text"
                                                    id="otp"
                                                    className="form-control form-control-md"
                                                    value={searchText}
                                                    onChange={onSearchLocation}
                                                    placeholder="Enter location"
                                                />
                                            </div>
                                            {searchResult.length !== 0 && <div className="dropdown">
                                                {renderSearchList()}
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="form-group" />
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Select location on the map
                                            </label>
                                            <div className="inner-feature-element-container__wrapper">
                                                <MapContainer
                                                    ref={mapRef}
                                                    center={position}
                                                    zoom={zoom}
                                                    zoomControl={true}
                                                    doubleClickZoom={true}
                                                    id="map"
                                                >
                                                    <TileLayer
                                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                                                    />
                                                    <Marker
                                                        draggable
                                                        opacity={0.8}
                                                        position={position}
                                                        icon={MarkerIcon}
                                                        eventHandlers={{
                                                            dragend: onDragMarker,
                                                        }}
                                                    >
                                                    </Marker>
                                                    <Circle
                                                        center={position}
                                                        radius={radius}
                                                        fillColor='red'
                                                    />
                                                </MapContainer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Select fence radius
                                            </label>
                                            <div>
                                                <input
                                                    type="range"
                                                    className="custom-range"
                                                    value={radius}
                                                    onChange={onChangeRadius}
                                                    min="0"
                                                    max="5000"
                                                    step="500"
                                                    id="range"
                                                />
                                                <span className="font-weight-bold text-primary ml-2 mt-1 valueSpan">{radius / 1000} km</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Select when to track
                                            </label>
                                            <div className="inner-multiple-feature-list-element__wrapper horizontal">
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="mon"
                                                        name="mon"
                                                        className="form-check-input"
                                                        onChange={onChangeMon}
                                                        checked={mon}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Monday
                                                    </label>
                                                </div>
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="tue"
                                                        name="tue"
                                                        className="form-check-input"
                                                        onChange={onChangeTue}
                                                        checked={tue}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Tuesday
                                                    </label>
                                                </div>
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="wed"
                                                        name="wed"
                                                        className="form-check-input"
                                                        onChange={onChangeWed}
                                                        checked={wed}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Wednesday
                                                    </label>
                                                </div>
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="thu"
                                                        name="thu"
                                                        className="form-check-input"
                                                        onChange={onChangeThu}
                                                        checked={thu}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Thursday
                                                    </label>
                                                </div>
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="fri"
                                                        name="fri"
                                                        className="form-check-input"
                                                        onChange={onChangeFri}
                                                        checked={fri}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Friday
                                                    </label>
                                                </div>
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="sat"
                                                        name="sat"
                                                        className="form-check-input"
                                                        onChange={onChangeSat}
                                                        checked={sat}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Saturday
                                                    </label>
                                                </div>
                                                <div className="form-check mb-4">
                                                    <input
                                                        type="checkbox"
                                                        id="sun"
                                                        name="sun"
                                                        className="form-check-input"
                                                        onChange={onChangeSun}
                                                        checked={sun}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexCheckDefault"
                                                    >
                                                        Sunday
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="validation invalid-feedback">{dayError}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Select time of the day
                                            </label>
                                            <TimePicker
                                                id="appt"
                                                name="appt"
                                                use12Hours
                                                format="h:mm A"
                                                className="form-control form-control-md"
                                                onChange={onChangeTime}
                                            // value={time ? dayjs(`2000-01-01 ${time}`) : null}
                                            />
                                            <div className="validation invalid-feedback">{validator.message('time', time, 'required')}</div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <label htmlFor="" className="form-label">
                                                Alert stop date
                                            </label>
                                            <DatePicker
                                                disabledDate={disabledDate}
                                                onChange={onChangeExpireDate}
                                                // value={expiredate ? dayjs(`2000-01-01 ${expiredate}`) : null}
                                                className="form-control form-control-md"
                                                id="expiredate"
                                                name="expiredate"
                                            />
                                            <div className="validation invalid-feedback">{validator.message('stop date', expiredate, 'required')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group__wrapper">
                                    <div className="form-group">
                                        <div className="form-element__wrapper mb-3">
                                            <input className="form-check-input" type="checkbox"
                                                checked={termsAndConditions}
                                                id="terms-acceptence"
                                                onChange={onConfirmationTerms} />
                                            <label className="form-check-label"
                                                htmlFor="terms-acceptence">
                                                Accept terms and conditions
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <p>
                                    {singleAppDetails !== null ? singleAppDetails?.widgetDetails?.termsAndConditions : ''}
                                </p>
                                <div className="panel-bottom-btn__wrapper">
                                    <button className="btn btn-secondary">Cancel</button>
                                    {renderSubmitButton()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    } else return (<React.Fragment></React.Fragment>);
}

export default LocationTrackCreate;